import { HttpEvent, HttpEventType } from '@angular/common/http';
import { forkJoin, Observable, Subject } from 'rxjs';
import { tap } from 'rxjs/operators';

export class UploadProgressSubject {
  constructor(
    public index: number,
    public progress: number,
    public total: number
  ) {}
}

function trackFileUploadProgress<T>(
  observable: Observable<T>,
  progressSubject: Subject<UploadProgressSubject>,
  index: number,
  total: number
): Observable<T> {
  return observable.pipe(
    tap(e => {
      try {
        const target = e as HttpEvent<T>;
        if (target.type === HttpEventType.UploadProgress) {
          const filePrecentage = Math.round(100 * target.loaded) / (target.total || 0);
          const progress = new UploadProgressSubject(index, filePrecentage, total);
          progressSubject.next(progress);
        }
      } catch (error) {
        console.error('Error monitoring file upload progress: ' + JSON.stringify(error));
      }
    })
  );
}

export function forkJoinWithProgress<T>(
  observables: Observable<T>[],
  progressSubject: Subject<UploadProgressSubject>
): Observable<T[]> {
  const trackedObservables = observables.map((observable, index) =>
    trackFileUploadProgress(observable, progressSubject, index, observables.length)
  );

  const finalResult = forkJoin(trackedObservables);

  return finalResult;
}
